// extracted by mini-css-extract-plugin
export default {"inputLabel":"TextArea_inputLabel__6ZSvv","tooltipRequired":"TextArea_tooltipRequired__YXmqh"};